export default Object.freeze({
  sign_up_url: "https://open-account.fyers.in/?utm_source=Direct-Traffic&utm_medium=MA_VerifiedPnL",
});
